import { useEffect } from "react";
import { useSelector } from "react-redux";
import { S3_BASE_URL } from "./Service";
import apterFavicon from "./assets/apterFavicon.png"

const DynamicHead = ({ host }) => {
  const domains = useSelector((state) => state.data.domains);

  // useEffect(() => {
  //   if (!domains || domains.length === 0 || !host) return;

  //   const matched = domains.find(site =>
  //     site.domainList.includes(host)
  //   );

  //   if (matched?.logo2) {
  //       const faviconUrl = `${S3_BASE_URL}/${matched.logo2}`;

  //     let favicon = document.getElementById("dynamic-favicon");
  //     if (!favicon) {
  //       favicon = document.createElement("link");
  //       favicon.rel = "icon";
  //       favicon.id = "dynamic-favicon";
  //       document.head.appendChild(favicon);
  //     }

  //     favicon.href = faviconUrl;
  //   }

  //   if (matched?.name) {
  //     document.title = matched.name;
  //   }
  // }, [domains, host]);


 useEffect(() => {
    if (!domains || domains.length === 0 || !host) return;

    const matched = domains.find((site) =>
      site.domainList.includes(host)
    );

    let faviconUrl;

    //  Check for specific theme
    if (matched?.appliedTheme === "theme6") {
      faviconUrl = apterFavicon; // Use assets logo for this theme
    } else if (matched?.logo2) {
      faviconUrl = `${S3_BASE_URL}/${matched.logo2}`;
    }

    if (faviconUrl) {
      let favicon = document.getElementById("dynamic-favicon");
      if (!favicon) {
        favicon = document.createElement("link");
        favicon.rel = "icon";
        favicon.id = "dynamic-favicon";
        document.head.appendChild(favicon);
      }
      favicon.href = faviconUrl;
    }

    if (matched?.title) {
      document.title = matched.title;
    }
  }, [domains, host]);


  return null; 
};

export default DynamicHead;